import Alert from "@/common/components/Alert";
import ResumeItem from "@/common/components/ResumeItem";
import { formatDateTime } from "@/common/utils/formatters";
import { useForwardingTabContext } from "@/features/maintenance/features/workflows/hooks/forwardings/useForwardingTabContext";
import { MaintenanceForwardingsDirectiveEntryKlass } from "@/features/maintenance/features/workflows/types/forwardings/maintenanceForwardingsDirectiveEntryKlasses.type";
import { CircleAlertIcon } from "lucide-react";

const DirectiveEntryExecutionEntryCompleted = () => {
  const {
    forwarding,
  } = useForwardingTabContext<MaintenanceForwardingsDirectiveEntryKlass.ExecutionEntry>();

  return (
    <>
      <div className="flex flex-col gap-3">
        <div className="flex gap-3">
          {forwarding.directive_entry?.completed_at && (
            <ResumeItem
              label="Manutenção finalizada"
              value={formatDateTime(new Date(forwarding.directive_entry?.completed_at))}
              className="text-xs"
              valueClassName="font-bold text-sm"
            />
          )}
        </div>

        <Alert
          variant="warning"
          Icon={CircleAlertIcon}
          iconClassName="size-6"
          containerClassName="bg-transparent p-0"
        >
          <p className="text-sm">
            Esse serviço já foi executado e será faturado após aprovação das suas notas fiscais.
          </p>
        </Alert>
      </div>
    </>
  );
}

export default DirectiveEntryExecutionEntryCompleted;
